// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rokid-theme{--coze-brand-5:25,100,250;--coze-brand-6:7,80,224;--semi-brand-5:25,100,250;--semi-brand-6:7,80,224;--semi-color-primary:#1964fa;--semi-color-primary-hover:#0750e0;--semi-color-focus-border:#1964fa;--semi-color-info:#1964fa}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
